import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import { database } from '../firebaseConfig';
import { useAuth } from '../context/AuthContext';
import { canUseCrm } from '../config/crm';
import { crmIdentity } from './CrmGate';

// Shows the CRM contact(s) a transaction was created from, with a link to each profile.
export default function LinkedContacts({ contactIds }) {
  const navigate = useNavigate();
  const auth = useAuth();
  const { userRole } = auth;
  const ids = Object.keys(contactIds || {});
  const key = ids.join(',');
  const [names, setNames] = useState({});
  useEffect(() => {
    if (!key) return;
    Promise.all(key.split(',').map((id) => get(ref(database, `crm/contacts/${id}/name`)).then((s) => [id, s.val()]).catch(() => [id, null])))
      .then((pairs) => setNames(Object.fromEntries(pairs)));
  }, [key]);
  if (!ids.length || !canUseCrm(userRole, crmIdentity(auth).uid, crmIdentity(auth).email)) return null;
  return (
    <div style={{ backgroundColor: '#F9F9F9', border: '1px solid #E0E0E0', borderRadius: 8, padding: '14px 20px', marginBottom: 16, fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}>
      <span style={{ fontSize: 13, fontWeight: 600, color: '#666', textTransform: 'uppercase', letterSpacing: '0.5px', marginRight: 10 }}>Contact profile</span>
      {ids.map((id) => (
        <button key={id} onClick={() => navigate(`/leads/contacts?id=${id}`)} style={{ background: 'none', border: 0, padding: 0, marginRight: 12, color: '#8C6D1F', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline', fontSize: 14 }}>
          {names[id] || 'Open contact'}
        </button>
      ))}
    </div>
  );
}
